import React from "react";
import "./style.css";

export default function Background() {
  return <div className="background-container"></div>;
}
